interface SEO {
    title?: string | null;
    description?: string | null;
    keywords?: (Keyword | null)[] | null;
    social?: Social | null;
    advanced?: Advanced | null;
}

interface Keyword {
    keyword: string | null;
    rating: string | null;
}

interface Social {
    twitter: Twitter | null;
    facebook: Facebook | null;
}

interface Twitter {
    title: string | null;
    description: string | null;
    image: Image | null;
}

interface Image {
    id: string | null;
    title: string | null;
    webp: string | null;
}

interface Facebook {
    title: string | null;
    description: string | null;
    image: Image | null;
}

interface Advanced {
    robots: any[] | null;
    canonical: string | null;
}

interface SEO_OBJ {
    [key: string]: string;
}

export function useSeoData(seo: SEO | null | undefined) {
    if (!seo) return;

    const route = useRoute();
    const seoObj = {} as SEO_OBJ;

    if (seo.title) seoObj.title = seo.title;
    if (seo.description) seoObj.description = seo.description;

    if (seo.keywords) {
        seoObj.keywords = seo.keywords
            .map(item => item?.keyword)
            .filter(Boolean)
            .join(', ');
    }

    if (seo.social) {
        if (seo.social.twitter) {
            seoObj.twitterCard = 'summary_large_image';
            seoObj.twitterSite = '';
            seoObj.twitterUrl = route.path;
            if (seo.social.twitter.title) seoObj.twitterTitle = seo.social.twitter.title;
            if (seo.social.twitter.description) seoObj.twitterDescription = seo.social.twitter.description;
            if (seo.social.twitter.image?.webp) seoObj.twitterImage = seo.social.twitter.image.webp;
        }

        if (seo.social.facebook) {
            seoObj.fbApp_id = '';
            seoObj.ogUrl = route.path;
            seoObj.ogType = 'website';

            if (seo.social.facebook.title) seoObj.ogTitle = seo.social.facebook.title;
            if (seo.social.facebook.image?.webp) {
                seoObj.ogImage = seo.social.facebook.image.webp;
                seoObj.ogImageWidth = '1200';
                seoObj.ogImageHeight = '600';
            }

            if (seo.social.facebook.description) {
                seoObj.ogDescription = seo.social.facebook.description;
            }

            seoObj.ogSite_name = 'Elle Midwives';
            seoObj.ogLocale = 'nl';
        }
    }

    useSeoMeta(seoObj);
}
